import { queryClient } from 'stateManagement/queries/client';

export const handleGetTracerData = async ({ action, navigate }) => {
  const {
    params: { tracerId },
  } = action;
  try {
    const tracerData = queryClient.getQueryData(['tracer', tracerId]);

    let toReturn = {
      rawData: tracerData,
    };

    return toReturn;
  } catch (error) {
    console.error('Failed to capture screenshot:', error);
    return null;
  }
};

